// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__149ET","delete":"styles_delete__8txwN","update":"styles_update__1gc4g","add":"styles_add__2Lati"};